import { request } from '../utils/request-utils';
import {
  uploadVideoLinkURL,
  deleteVideoLinkURL,
  getVideoLinkURL,
} from './urls';

export const uploadVideoLink = async ({
  houseType,
  houseId,
  url,
  videoSource,
}) =>
  request(uploadVideoLinkURL(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      externalDomain: houseType,
      externalDomainId: houseId,
      url,
      videoSource,
    }),
  });

export const deleteVideoLinkApi = async videoId =>
  request(deleteVideoLinkURL(videoId), {
    method: 'DELETE',
  });

export const fetchVideoLink = async (houseType, houseId) =>
  request(getVideoLinkURL(houseType, houseId), {
    method: 'GET',
  });
